export default __webpack_public_path__ + "static/media/Logo_Trust_NIAS@3x.40938c46.png";